<template>
  <div class="content-wrapper">
    <FlashMessages />
    <router-view :key="routeKey" />
  </div>
</template>

<script>
const toKebabCase = string => string?.replace(/([A-Z])/g, '-$1')?.toLowerCase();

export default {
  components: {
    FlashMessages: () => import('~/modules/FlashMessages.vue'),
  },
  computed: {
    routeKey() {
      return this.$route.name;
    },
  },
  watch: {
    $route(to, from) {
      document.body.classList.add(toKebabCase(to.name));
      document.body.classList.remove(toKebabCase(from.name));

      if (window.disabledTracking !== true) {
        this.$posthog?.capture('$pageview');
      }
    },
  },
};
</script>
